module.exports = __webpack_public_path__ + "img/76240.46d161e6.svg";